import React from 'react';
import type { ColumnDef } from '@tanstack/react-table';

import TruncatedCell from 'components/partials/table-component/truncated-cell/truncated-cell';

import { formatDate } from 'helpers/dates-formatter';

import { ModelNameCell } from './components/model-name-cell';
import { ModelActionCell } from './components/model-action-cell';
import type { AidModelRowActions } from './components/model-action-cell';

import { getAidModelDetailsPath } from './aid-studio-details/utils/aid-studio-paths';

import type { AidModelDto } from 'api/generated/schemas/aidModelDto';

const commonStyles = 'border-r-2 border-white font-semibold cursor-pointer';

export const getAidStudioTableSettings = (
  clientId: number,
  actions: AidModelRowActions,
  isUserView?: boolean
): ColumnDef<AidModelDto>[] => [
  {
    id: 'name',
    accessorKey: 'name',
    header: () => <span>MODEL NAME</span>,
    cell: (info) => (
      <ModelNameCell
        model={info.row.original}
        detailsPath={getAidModelDetailsPath(
          clientId,
          info.row.original.id,
          isUserView
        )}
      />
    ),
    headerClassName: `${commonStyles} rounded-tl-md rounded-bl-md`,
    className: 'w-[29%] text-left font-semibold pl-3 max-w-0',
    enableSorting: true,
    sortingFn: 'alphanumeric',
  },
  {
    id: 'entryTerm',
    accessorKey: 'entryTerm',
    header: () => <span>YEAR</span>,
    cell: (info) => info.renderValue() as React.ReactNode,
    headerClassName: `${commonStyles} px-4`,
    className: 'w-[9%] text-center',
    isHeaderCentered: true,
    enableSorting: true,
  },
  {
    id: 'createdDate',
    accessorKey: 'createdDate',
    header: () => <span>UPDATED</span>,
    cell: (info) => formatDate(info.getValue() as string, 'MM.DD.YYYY'),
    headerClassName: commonStyles,
    className: 'w-[9%] text-center',
    isHeaderCentered: true,
    enableSorting: true,
  },
  {
    id: 'createdBy',
    accessorKey: 'createdBy',
    header: () => <span>AUTHOR</span>,
    cell: (info) => <TruncatedCell value={String(info.renderValue() ?? '')} />,
    headerClassName: commonStyles,
    className: 'w-[20%] text-left pl-4 max-w-0',
    enableSorting: true,
  },
  {
    id: 'description',
    accessorKey: 'description',
    header: () => <span>DESCRIPTION</span>,
    cell: (info) => <TruncatedCell value={String(info.renderValue() ?? '')} />,
    headerClassName: commonStyles,
    className: 'w-[28%] text-left pl-4 max-w-0',
    enableSorting: false,
  },
  {
    id: 'button-cell',
    cell: (info) => (
      <ModelActionCell
        model={info.row.original}
        detailsPath={getAidModelDetailsPath(
          clientId,
          info.row.original.id,
          isUserView
        )}
        actions={actions}
      />
    ),
    headerClassName: 'h-12 rounded-tr-md rounded-br-md',
    className: 'w-[5%] flex justify-center w-full py-3',
  },
];
